module.exports = __webpack_public_path__ + "static/fonts/AvenirLTProHeavy.ad8e86a.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/quiz-fonts/AvenirLTProHeavy.eot
// module id = hZ+s
// module chunks = 1